import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Home from "./pages/Home";
import SimpleLayout from "./layouts/simple";
import Page404 from "./pages/Page404";
import ContactCard from "./pages/ContactCard";
import ThankYou from "./pages/ThankYou";

export default function Router() {
  const routes = useRoutes([
    {
      path: "/",
      element: <Home />,
      index: true,
    },
    {
      element: <SimpleLayout />,
      children: [
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "/contact-card",
      element: <ContactCard />
    },
    {
      path: "/thank-you",
      element: <ThankYou />
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);
  return routes;
}
